import React from "react"
import styled from "styled-components"

import Spacer from "~/components/Spacer"
import colors from "~/style/theme/colors"

const Text = styled.div`
  color: ${(props) =>
    props.color ? props.color : props.theme.colors.text.label};
  font-family: ${(props) => props.theme.fonts.avenirNextRegular};
  font-size: 3em;
  text-align: center;
  ${(props) =>
    props.subHeader &&
    `
    font-size: 1.2em;
    max-width: 390px;
    width: 100%;
    padding: 1px;
  `}
`

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`

const Title = () => {
  return (
    <>
      <Spacer mobile={15} desktop={40} />
      <Text as="h1" style={{ margin: "0" }} color={colors.text.header}>
        HOW IT WORKS
      </Text>
      <Spacer mobile={6} desktop={6} />
      <Container>
        <Text subHeader>
          Be aware that traffic ticket and parking ticket disputes are entirely
          separate processes.
        </Text>
      </Container>
    </>
  )
}

export default Title
